<template>
  <v-snackbar 
    :color="snackBarType"
    multi-line
    v-model="snackBarshow">
    {{snackBarmessage}}
    <v-btn text  @click="snackBarshow = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
export default {
  data () {
    return {
    }
  },
      computed : {
    ...mapFields([
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
}
}
</script>